'use strict';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { ICurationItem } from '../../../interfaces/curation-item.interface';
import { CurationUtils } from '../../../utils/curation-utils';
import { HISTORY_COLUMN_TYPE, IHistoryColumnData } from '../../../../shared/interfaces/history.interface';
import { IRevision } from '../../../../core/interfaces/workflow.interface';
import { Observable } from 'rxjs';
import { CurationSettings } from '../../curation-dashboard/curation-setting';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'gen-curation-editor-header',
  templateUrl: './curation-editor-header.component.html',
  styleUrls: ['./curation-editor-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationEditorHeaderComponent implements OnInit, OnChanges {
  @Output() revisionSelected: EventEmitter<{ revisionId: string, revisionData: any}> = new EventEmitter();
  @Input() revisionsData$: Observable<Array<{ revision: IRevision, item: { [prop: string]: any}}>>;
  @Input() readOnlyUserMode: boolean = false;
  @Input() revisionLastUpdatedDate: {[prop: string]: string};
  @Input() lastManualOpinionName: string;

  private curItem: ICurationItem;
  private curStatus: string;
  private rejectMsg: string;
  public currentRevisionName: string;
  public status: any;
  public titleLabel: string;
  public titleText: string;
  public currentRevisionId: string;
  public revisionsColumns: Array<IHistoryColumnData> =
    [{ key: 'name', type: HISTORY_COLUMN_TYPE.TEXT}, { key: 'meta.lastUpdated', type: HISTORY_COLUMN_TYPE.DATE}];

  constructor(private datePipe: DatePipe) {
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkChanges();
  }
  @Input() set revisionName(name: string) {
    this.currentRevisionName = name;
  }

  get revisionName(): string {
    return this.currentRevisionName;
  }

  @Input() set rejectMessage(msg: string) {
    this.rejectMsg = msg;
  }

  get rejectMessage(): string {
    return this.rejectMsg;
  }

  @Input() set curationStatus(status: string) {
    this.curStatus = status;
  }
  get curationStatus(): string {
    return this.curStatus;
  }

  @Input() set curationItem(item: ICurationItem) {
    this.curItem = item;
    const currentRevisionId = this.curItem?.currentWorkflowRequestRevision || this.curItem?.curationData['revisionId']; // support old and new struct
    this.currentRevisionId = currentRevisionId;
  }
  get curationItem(): ICurationItem {
    return this.curItem;
  }

  private checkChanges() {
    this.status = CurationUtils.getCurationStatusDisplayString(this.curStatus);
    if (this.curStatus === CurationSettings.CURATION_STATUS_DRAFT ||
      this.curationStatus === CurationSettings.CURATION_STATUS_APPROVED_SUBMITTED ||
      this.curationStatus === CurationSettings.CURATION_STATUS_ARCHIVED_SUBMITTED ||
      this.curationStatus === CurationSettings.CURATION_STATUS_PUBLISHED_SUBMITTED
    ) {
      if (this.curItem.opinion) {
        this.titleLabel = 'Last updated: ';
        this.updateTitleAccordingLatestAction();
      }
      else {
        this.titleLabel = '';
        this.titleText = '';
      }
    }
    else if (this.curStatus === 'waitforapproval') {
      this.titleLabel = 'Submitted By: ';
      this.updateTitleAccordingLatestAction();
    }
    else if (this.curStatus === CurationSettings.CURATION_STATUS_REJECTED) {
      this.titleLabel = 'Rejected By: ';
      this.updateTitleAccordingLatestAction();
    }

    else if (this.curStatus === CurationSettings.CURATION_STATUS_APPROVED) {
      this.titleLabel = 'Approved By: ';
      this.updateTitleAccordingLatestAction();
    }

    else if (this.curStatus === CurationSettings.CURATION_STATUS_PUBLISHED) {
        this.titleLabel = 'Published By: ';
        this.updateTitleAccordingLatestAction();
    }

    else if (this.curStatus === CurationSettings.CURATION_STATUS_WAITING_FOR_ARCHIVE) {
      this.titleLabel = 'Requested by: ';
      this.updateTitleAccordingLatestAction();
    }

    else if (this.curStatus === 'archived') {
      this.titleLabel = 'Archived by: ';
      this.updateTitleAccordingLatestAction();
    }
  }

  updateTitleAccordingLatestAction() {
    if (this.curItem.opinion) {
      const lastUpdated = new Date(this.curItem.opinion.meta.lastUpdated);
      const newDateValue = this.datePipe.transform(lastUpdated,"d MMM y");
      // const dateToShow: any = (<any> lastUpdated).toPlatformFormat();
      // const dateToShow: any = (<any> lastUpdated).toPlatformFormat();
      const prefix = this.curItem.opinion.prefix == undefined ? '' : this.curItem.opinion.prefix  + ' ';
      const name = this.curItem.opinion.name == undefined ? (this.curItem.curationData != undefined && this.curItem.curationData['performerName'] != undefined ? prefix + this.curItem.curationData['performerName'] + ', ' : '') : prefix + this.curItem.opinion.name + ', ';
      this.titleText = name + newDateValue;
    }
  }

  historyRowClick($event) {
    this.revisionSelected.emit({ revisionId: $event.revisionId, revisionData: $event.revisionData});
  }
}
